<template>
  <div class="layout">
    <NavbarHero
      :is-fixed="isHomePage"
      @open-login="openLogin"
      @open-signup="openSignup"
      @close-login="closeLogin"
      @close-signup="closeSignup"
      @change-signup="changeSignup"
      @change-login="changeLogin"
    />
    <main :class="mainClass">
      <slot />
      <Analytics />
      <SpeedInsights />
    </main>
    <NewsletterPopup />
    <!-- Pop-up bileşeni -->
    <FooterPage />
  </div>
</template>

<script setup>
import { SpeedInsights } from "@vercel/speed-insights/nuxt";
import { Analytics } from "@vercel/analytics/nuxt";
import FooterPage from "~/components/FooterPage.vue";
import NavbarHero from "~/components/NavbarHero.vue";
import NewsletterPopup from "~/components/NewsletterPopup.vue";
import { useRoute } from "vue-router";
import { computed, watchEffect } from "vue";
import { useAuthModal } from "~/composables/useAuthModal";

const route = useRoute();
const isHomePage = computed(() =>
  ["/", "/tr", "/en", "/tr/", "/en/"].includes(route.path)
);

const mainClass = computed(() =>
  isHomePage.value ? "" : "pt-[72px] md:pt-[100px]"
);

const {
  openLogin,
  openSignup,
  closeLogin,
  closeSignup,
  changeLogin,
  changeSignup,
} = useAuthModal();
</script>
